var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 2H8C5.80702 2 4 3.80702 4 6V18C4 20.193 5.80702 22 8 22H16C18.193 22 20 20.193 20 18V10.3333C20 9.5614 19.4386 9 18.6667 9H13V3.33333C13 2.5614 12.4386 2 11.6667 2ZM18 10V12C18 12.5439 18.4561 13 19 13C19.5439 13 20 12.5439 20 12V10C20 9.45614 19.5439 9 19 9C18.4561 9 18 9.45614 18 10ZM10 4H12C12.5439 4 13 3.54386 13 3C13 2.45614 12.5439 2 12 2H10C9.45614 2 9 2.45614 9 3C9 3.54386 9.45614 4 10 4ZM11.2982 3.70176L18.2982 10.7018C18.4737 10.8947 18.7193 11 19 11C19.5439 11 20 10.5439 20 10C20 9.7193 19.8947 9.47368 19.7018 9.29825L12.7018 2.29825C12.5263 2.10526 12.2807 2 12 2C11.4561 2 11 2.45614 11 3C11 3.2807 11.1053 3.52632 11.2982 3.70176Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.ea626ad8.svg";
export { ForwardRef as ReactComponent };